var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDataCategory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 130,
    viewBox: "0 0 137 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1970)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_94_1970",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.5005,
    y: 32.6006,
    width: 22.4,
    height: 15.4,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.5005,
    y: 32.6006,
    width: 22.4,
    height: 15.4,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_94_1970)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_94_1970",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.6006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.6006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_94_1970)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_94_1970",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.1006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.1006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_94_1970)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_94_1970",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.1006,
    y: 79.5005,
    width: 17.5,
    height: 12.6,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4_94_1970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7007 51.5005V76.0005",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2007 76.0005V62.0005H93.2007V76.0005",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1970",
    x: 0.100586,
    y: 0.400586,
    width: 136.5,
    height: 129.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.219608 0 0 0 0 0.898039 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1970",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataCategory);
export default __webpack_public_path__ + "static/media/icon_data_category.314f7b9b0593fd2dd1c6dd8cc6696f97.svg";
export { ForwardRef as ReactComponent };